.rasa-button {
  height: 32px;
  border: 1px solid var(--message-button-border-color);
  border-radius: 8px;
  padding: 8px 12px;
  background-color: var(--message-button-background-color);
  color: var(--message-button-color);
  font-family: var(--font-family);
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 0.3px;
  padding-top: 6px;
  padding-bottom: 6px;
  text-wrap: nowrap;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  vertical-align: middle;

  &--selected {
    background-color: var(--message-selected-button-background-color);
    color: var(--message-selected-button-color);
    border: 1px solid var(--message-selected-button-border-color);
  }
}
